import React, { useEffect } from 'react';

const UI = {
  spacing: { xs: 6, sm: 8, md: 12, lg: 16, xl: 24 },
  radius: { sm: 6, md: 8, lg: 12 },
  colors: {
    primary: "#0F172A",
    secondary: "#334155",
    muted: "#64748B",
    border: "#E2E8F0",
    bg: "#F8FAFC",
    success: "#059669",
    warning: "#D97706",
    danger: "#DC2626",
    info: "#3B82F6"
  }
};

const Modal = ({ isOpen, onClose, title, children, maxWidth = 480 }) => {
  useEffect(() => {
    if (isOpen) {
      const handleEscape = (e) => {
        if (e.key === 'Escape') onClose();
      };
      document.addEventListener('keydown', handleEscape);
      return () => document.removeEventListener('keydown', handleEscape);
    }
  }, [isOpen, onClose]);
  
  if (!isOpen) return null;
  
  return (
    <>
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0,0,0,0.5)',
          zIndex: 1000
        }}
        onClick={onClose}
      />
      <div
        style={{
          position: 'fixed',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '90%',
          maxWidth,
          background: UI.colors.white,
          borderRadius: UI.radius.lg,
          zIndex: 1001,
          animation: 'modalSlideIn 0.2s ease'
        }}
      >
        <style>{`
          @keyframes modalSlideIn {
            from {
              opacity: 0;
              transform: translate(-50%, -48%);
            }
            to {
              opacity: 1;
              transform: translate(-50%, -50%);
            }
          }
        `}</style>
        
        <div style={{
          padding: UI.spacing.lg,
          borderBottom: `1px solid ${UI.colors.border}`,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <div style={{
            fontFamily: "'Playfair Display', serif",
            fontSize: 16,
            fontWeight: 700,
            color: UI.colors.primary
          }}>
            {title}
          </div>
          <button
            onClick={onClose}
            style={{
              background: 'none',
              border: 'none',
              fontSize: 20,
              cursor: 'pointer',
              color: UI.colors.muted
            }}
          >
            ✕
          </button>
        </div>
        
        <div style={{ padding: UI.spacing.lg }}>
          {children}
        </div>
      </div>
    </>
  );
};

export default Modal;